import styled from 'styled-components'

import Icon from '~/components/icon'
import { device } from '~/styles/utils'

import type { FixedGlyphIcon } from '~/components/icon'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 25px;

  font-size: 14px;

  @media ${device('notMobile')} {
    max-width: 478px;
  }
`
export const AlertIcon: FixedGlyphIcon = styled(Icon).attrs({
  glyph: 'triangle-exclamation',
})`
  color: ${({ theme }) => theme.color.icon.default};
  margin-right: 13.9px;
  flex-grow: 0;
  &::before {
    font-size: 30px;
  }
`
